import { format } from "date-fns";
import { KEY } from "../constants/common.const";

export function updateOriginMachineWithStatus(
  machine,
  allHaveCheckTime,
  lengthCheckTime
) {
  if (!machine || !Array.isArray(machine.checkItems)) return machine;

  const clonedMachine = JSON.parse(JSON.stringify(machine));

  const checkItems = clonedMachine.checkItems.map((item) => ({
    id: item.id,
    checklistItemId: item.checklistItemId,
    value: item.value,
    checkTime: item.checkTime,
    previousTime: item.previousTime,
    inspectionTime: item.inspectionTime,
    inputJudgment: item.inputJudgment,
    previousValue: item.previousValue,
    replenishmentAmount: item.replenishmentAmount,
    note: item.note,
    previousAccumulatedValue: item.previousAccumulatedValue,
    normalLowerControlValue: item.normalLowerControlValue,
    normalUpperControlValue: item.normalUpperControlValue,
    type: item.type,
    defaultTime: item.defaultTime,
    defaultCheckItemName: item.defaultCheckItemName,
    defaultMachineForSiteOfficeName: item.defaultMachineForSiteOfficeName,
    defaultChecklistName: item.defaultChecklistName,
    accumulatedType: item.accumulatedType || 1,
  }));

  const processItems = (items) => {
    const errorItems = [];
    let itemHasDone = 0;
    const totalItems = items.length;

    for (const item of items) {
      const val =
        item.value !== null && item.value !== ""
          ? parseFloat(item.value)
          : null;
      const replenishment = item.replenishmentAmount;
      const isAccumulated = Number(item.accumulatedType) === 3;
      const hasValue =
        val !== null &&
        (!isAccumulated || (replenishment !== "" && replenishment !== null));

      if (hasValue) itemHasDone++;

      if (val !== null) {
        const upper = item.normalUpperControlValue;
        const lower = item.normalLowerControlValue;
        let isError = false;

        if (
          upper !== null &&
          upper !== "" &&
          lower !== null &&
          lower !== "" &&
          !(Number(lower) <= val && val <= Number(upper))
        )
          isError = true;

        if ((!upper || upper === "") && lower && val < Number(lower))
          isError = true;
        if ((!lower || lower === "") && upper && val > Number(upper))
          isError = true;

        if (isError) errorItems.push(item.id);
      }
    }

    return { errorItems, itemHasDone, totalItems };
  };

  let newErrorId;
  let newResultStatus;
  let newNoneInput;

  if (allHaveCheckTime) {
    newErrorId = {};
    newResultStatus = {};
    newNoneInput = {};

    const groupByCheckTime = {};
    for (let i = 1; i <= lengthCheckTime; i++) {
      groupByCheckTime[i] = [];
      newErrorId[i] = [];
      newResultStatus[i] = 0;
      newNoneInput[i] = null;
    }

    for (const item of checkItems) {
      const key = item.checkTime;
      if (key !== 0) {
        if (!groupByCheckTime[key]) groupByCheckTime[key] = [];
        groupByCheckTime[key].push(item);
      }
    }

    for (const item of checkItems) {
      if (item.checkTime === 0) {
        for (let i = 1; i <= lengthCheckTime; i++) {
          groupByCheckTime[i].push(item);
        }
      }
    }

    for (const [checkTime, items] of Object.entries(groupByCheckTime)) {
      const { errorItems, itemHasDone, totalItems } = processItems(items);

      newErrorId[checkTime] = errorItems;

      if (itemHasDone === 0) {
        newResultStatus[checkTime] = 0;
        newNoneInput[checkTime] = null;
      } else if (errorItems.length) {
        newResultStatus[checkTime] = 2;
        newNoneInput[checkTime] = totalItems - itemHasDone;
      } else if (itemHasDone === totalItems) {
        newResultStatus[checkTime] = 3;
        newNoneInput[checkTime] = 0;
      } else {
        newResultStatus[checkTime] = 1;
        newNoneInput[checkTime] = totalItems - itemHasDone;
      }
    }
  } else {
    const { errorItems, itemHasDone, totalItems } = processItems(checkItems);
    newErrorId = errorItems;
    if (itemHasDone === 0) {
      newResultStatus = 0;
      newNoneInput = null;
    } else if (errorItems.length) {
      newResultStatus = 2;
      newNoneInput = totalItems - itemHasDone;
    } else if (itemHasDone === totalItems) {
      newResultStatus = 3;
      newNoneInput = 0;
    } else {
      newResultStatus = 1;
      newNoneInput = totalItems - itemHasDone;
    }
  }

  clonedMachine.errorId = newErrorId;
  clonedMachine.resultMachineStatus = newResultStatus;
  clonedMachine.noneInput = newNoneInput;

  return clonedMachine;
}
export function updateMachineChecklistStatus(machine, allHaveCheckTime,lengthCheckTime = 0) {
  if (!machine || !Array.isArray(machine.CheckResultContent)) return machine;

  const clonedMachine = JSON.parse(JSON.stringify(machine));

  const checkItems = clonedMachine.CheckResultContent.map((item) => ({
    id: item.checkItemId,
    checklistItemId: item.checklistItemID,
    value: item.value,
    checkTime: item.checkTime,
    previousTime: item.previousTime,
    inspectionTime: item.inspectionTime,
    inputJudgment: item.inputJudgment,
    previousValue: item.previousValue,
    replenishmentAmount: item.replenishmentAmount,
    note: item.note,
    previousAccumulatedValue: item.previousAccumulatedValue,
    normalLowerControlValue: item.normalLowerControlValue,
    normalUpperControlValue: item.normalUpperControlValue,
    type: item.type,
    defaultTime: item.defaultTime,
    defaultCheckItemName: item.defaultCheckItemName,
    defaultMachineForSiteOfficeName: item.defaultMachineForSiteOfficeName,
    defaultChecklistName: item.defaultChecklistName,
    accumulatedType: item.accumulatedType || 1,
  }));

  const processItems = (items) => {
    const errorItems = [];
    let itemHasDone = 0;
    const totalItems = items.length;

    for (const item of items) {
      const val =
        item.value !== null && item.value !== ""
          ? parseFloat(item.value)
          : null;
      const replenishment = item.replenishmentAmount;
      const isAccumulated = Number(item.accumulatedType) === 3;
      const hasValue =
        val !== null &&
        (!isAccumulated || (replenishment !== "" && replenishment !== null));

      if (hasValue) itemHasDone++;

      if (val !== null) {
        const upper = item.normalUpperControlValue;
        const lower = item.normalLowerControlValue;
        let isError = false;

        if (
          upper !== null &&
          upper !== "" &&
          lower !== null &&
          lower !== "" &&
          !(Number(lower) <= val && val <= Number(upper))
        )
          isError = true;

        if ((!upper || upper === "") && lower && val < Number(lower))
          isError = true;
        if ((!lower || lower === "") && upper && val > Number(upper))
          isError = true;

        if (isError) errorItems.push(item.id);
      }
    }

    return { errorItems, itemHasDone, totalItems };
  };

  let newErrorId;
  let newResultStatus;
  let newNoneInput;

  if (allHaveCheckTime) {
    newErrorId = {};
    newResultStatus = {};
    newNoneInput = {};

    const groupByCheckTime = {};

    for (let i = 1; i <= lengthCheckTime; i++) {
      groupByCheckTime[i] = [];
      newErrorId[i] = [];
      newResultStatus[i] = 0;
      newNoneInput[i] = 0;
    }

    for (const item of checkItems) {
      const key = item.checkTime;
      if (key !== 0) {
        if (!groupByCheckTime[key]) groupByCheckTime[key] = [];
        groupByCheckTime[key].push(item);
      }
    }

    for (const item of checkItems) {
      if (item.checkTime === 0) {
        for (let i = 1; i <= lengthCheckTime; i++) {
          groupByCheckTime[i].push(item);
        }
      }
    }
    for (const [checkTime, items] of Object.entries(groupByCheckTime)) {
      const { errorItems, itemHasDone, totalItems } = processItems(items);

      newErrorId[checkTime] = errorItems;

      if (itemHasDone === 0) {
        newResultStatus[checkTime] = 0;
        newNoneInput[checkTime] = null;
      } else if (errorItems.length) {
        newResultStatus[checkTime] = 2;
        newNoneInput[checkTime] = totalItems - itemHasDone;
      } else if (itemHasDone === totalItems) {
        newResultStatus[checkTime] = 3;
        newNoneInput[checkTime] = 0;
      } else {
        newResultStatus[checkTime] = 1;
        newNoneInput[checkTime] = totalItems - itemHasDone;
      }
    }
  } else {
    const { errorItems, itemHasDone, totalItems } = processItems(checkItems);
    newErrorId = errorItems;
    if (itemHasDone === 0) {
      newResultStatus = 0;
      newNoneInput = null;
    } else if (errorItems.length) {
      newResultStatus = 2;
      newNoneInput = totalItems - itemHasDone;
    } else if (itemHasDone === totalItems) {
      newResultStatus = 3;
      newNoneInput = 0;
    } else {
      newResultStatus = 1;
      newNoneInput = totalItems - itemHasDone;
    }
  }
  clonedMachine.errorId = newErrorId;
  clonedMachine.resultMachineStatus = newResultStatus;
  clonedMachine.noneInput = newNoneInput;
  return clonedMachine;
}

function flattenCheckItems(groups) {
  const allItems = [];

  for (let g = 0; g < groups.length; g++) {
    const group = groups[g];
    const groupId = group.id;
    const machines = group.checklistMachines;

    if (Array.isArray(machines)) {
      for (let m = 0; m < machines.length; m++) {
        const machine = machines[m];
        const machineId = machine.id;
        const items = machine.checkItems;

        if (Array.isArray(items)) {
          for (let i = 0; i < items.length; i++) {
            const item = { ...items[i] };
            item.machineId = machineId;
            item.groupId = groupId;
            item.groupIndex = g;
            allItems.push(item);
          }
        }
      }
    }
  }

  return allItems;
}
function findCheckItemByCode(groups, targetCode, checkTime) {
  for (let g = 0; g < groups.length; g++) {
    const group = groups[g];
    const machines = group.checklistMachines;

    if (Array.isArray(machines)) {
      for (let m = 0; m < machines.length; m++) {
        const machine = machines[m];
        const items = machine.checkItems;

        if (Array.isArray(items)) {
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (!checkTime) {
              if (item.checkItemCode === targetCode) {
                return item;
              }
            } else {
              if (
                item.checkItemCode === targetCode &&
                checkTime == item.checkTime
              ) {
                return item;
              }
            }
          }
        }
      }
    }
  }

  return null;
}
function findCheckResultItemByCheckItemId(
  listMachines,
  targetCheckItemId,
  checkTime
) {
  if (!Array.isArray(listMachines)) return null;

  for (let i = 0; i < listMachines.length; i++) {
    const machine = listMachines[i];
    if (!machine || !Array.isArray(machine.CheckResultContent)) continue;

    for (let j = 0; j < machine.CheckResultContent.length; j++) {
      const item = machine.CheckResultContent[j];
      if (!checkTime) {
        if (item && item.checkItemId === targetCheckItemId) {
          return item;
        }
      } else {
        if (
          item &&
          item.checkItemId === targetCheckItemId &&
          item.checkTime == checkTime
        ) {
          return item;
        }
      }
    }
  }

  return null;
}
// Sync Data Ref
export function syncCheckItemRefs(checklistResult, inspectionTime) {
  const allItem = flattenCheckItems(checklistResult.checklistGroups) || [];
  const machines = checklistResult.ChecklistMachine || [];
  allItem.forEach((checkItem) => {
    const checkTime = checkItem.checkTime;
    const isOriginHide =
      !checkItem.checkItemCodeRef && checkItem.defaultType == 5;
    const refItem = findCheckItemByCode(
      checklistResult.checklistGroups,
      checkItem.checkItemCode,
      checkTime
    );
    const refMachine = findCheckResultItemByCheckItemId(
      machines,
      checkItem.id,
      checkTime
    );
    if (checkItem.checkItemCodeRef) {
      const originItem = allItem.find((i) => {
        if (!checkTime) {
          return i.checkItemCode === checkItem.checkItemCodeRef;
        } else
          return (
            (i.checkItemCode === checkItem.checkItemCodeRef &&
              i.checkTime == checkItem.checkTime) ||
            (i.checkItemCode === checkItem.checkItemCodeRef &&
              i.checkTime === 0)
          );
      });

      if (originItem) {
        if (refItem) {
          refItem.value = originItem.value;
          refItem.inspectionTime = originItem.inspectionTime;
        }
        if (refMachine) {
          refMachine.value = originItem.value;
          refMachine.inspectionTime = originItem.inspectionTime;
        }
      }
    }

    // Handle if origin hide
    if (isOriginHide) {
      if (refItem) {
        refItem.inspectionTime =
          inspectionTime || format(new Date(), KEY.HOUR_24H);
      }
      if (refMachine) {
        refMachine.inspectionTime =
          inspectionTime || format(new Date(), KEY.HOUR_24H);
      }
    }
  });
  return checklistResult;
}

// Map Ref data
export const mapRefdataItemMachine = (item, currentAllListItemCL = []) => {
  if (item.checkItemCodeRef) {
    const currentItem = currentAllListItemCL.find((i) => {
      if (item.checkTime) {
        return (
          (item.checkItemCodeRef === i.checkItemCode &&
            i.checkTime == item.checkTime) ||
          (item.checkItemCodeRef === i.checkItemCode && i.checkTime === 0)
        );
      }
      return item.checkItemCodeRef === i.checkItemCode;
    });

    if (currentItem) {
      item.value = currentItem.value || "";
    }
  }
};
